// Category-Capabilities (CC) matrix — the ONE shared FE reader of operation_category_rules.
// Mirrors the server's operationAllowsCategory: an absent cell = allowed (fail-open), so the FE
// only ever *narrows* pickers to what the server will accept; the server re-enforces every cell.
//
// buildCapabilityLookup(rulesResp) → { [operation]: { [categoryLower]: boolean } }
//   accepts either the raw GET /api/operation-category-rules response ({ rules: [...] }) or a bare array.
// opAllowsCat(cap, operation, category) → boolean (unknown cell = true).

export function buildCapabilityLookup(rulesResp) {
  const rules = rulesResp?.rules || (Array.isArray(rulesResp) ? rulesResp : []);
  const m = {};
  for (const r of rules) { (m[r.operation] ||= {})[String(r.category).toLowerCase()] = !!r.allowed; }
  return m;
}

export function opAllowsCat(cap, operation, category) {
  const v = cap?.[operation]?.[String(category || '').toLowerCase()];
  return v === undefined ? true : v;   // unknown cell = allowed (no rule = allow), matches server
}
